export interface CarouselProperties {
    autoSlide?: boolean;
    slideInterval?: number;
    animationDuration?: number;
    showIndicators?: boolean;
}

//=========== Set default values for carousel properties ===========
export class DefaultCarouselProperties implements CarouselProperties {
    autoSlide: boolean = false;
    slideInterval: number = 3000;
    animationDuration: number = 500;
    showIndicators: boolean = true;

    constructor(properties?: Partial<CarouselProperties>) {
        if (properties) {
            Object.assign(this, properties);
        }
    }
}
   